/**
 * Partier i Ale kommun. Färger följer gängse svensk mediepalett.
 * `FiA` = Framtid i Ale (lokalt parti). Okända partier som dyker upp i
 * valdata faller tillbaka på `UNKNOWN_PARTY`.
 */
export const PARTIES = [
    {
        code: 'V',
        shortName: 'V',
        name: 'Vänsterpartiet',
        color: '#af0000',
        onColor: '#ffffff',
        order: 10,
        bloc: 'vanster',
    },
    {
        code: 'S',
        shortName: 'S',
        name: 'Socialdemokraterna',
        color: '#e8112d',
        onColor: '#ffffff',
        order: 20,
        bloc: 'vanster',
    },
    {
        code: 'MP',
        shortName: 'MP',
        name: 'Miljöpartiet de gröna',
        color: '#83cf39',
        onColor: '#000000',
        order: 30,
        bloc: 'vanster',
    },
    {
        code: 'FiA',
        shortName: 'FiA',
        name: 'Framtid i Ale',
        color: '#7d5ba6',
        onColor: '#ffffff',
        order: 40,
        bloc: 'ovrigt',
    },
    {
        code: 'C',
        shortName: 'C',
        name: 'Centerpartiet',
        color: '#009933',
        onColor: '#ffffff',
        order: 50,
        bloc: 'center-hoger',
    },
    {
        code: 'L',
        shortName: 'L',
        name: 'Liberalerna',
        color: '#006ab3',
        onColor: '#ffffff',
        order: 60,
        bloc: 'center-hoger',
    },
    {
        code: 'KD',
        shortName: 'KD',
        name: 'Kristdemokraterna',
        color: '#231977',
        onColor: '#ffffff',
        order: 70,
        bloc: 'center-hoger',
    },
    {
        code: 'M',
        shortName: 'M',
        name: 'Moderaterna',
        color: '#52bdec',
        onColor: '#000000',
        order: 80,
        bloc: 'center-hoger',
    },
    {
        code: 'SD',
        shortName: 'SD',
        name: 'Sverigedemokraterna',
        color: '#dddd00',
        onColor: '#000000',
        order: 90,
        bloc: 'sd',
    },
];
export const UNKNOWN_PARTY = {
    shortName: '?',
    name: 'Övrigt parti',
    color: '#9aa0a6',
    onColor: '#000000',
    order: 999,
    bloc: 'ovrigt',
};
const BY_CODE = new Map(PARTIES.map((p) => [p.code, p]));
/** Slår upp ett parti. Okänd kod → syntetiskt "Övrigt"-parti (aldrig undefined). */
export function getParty(code) {
    return BY_CODE.get(code) ?? { code, ...UNKNOWN_PARTY };
}
export function partyOrder(code) {
    return getParty(code).order;
}
//# sourceMappingURL=parties.js.map